import { capitalize } from 'lodash';
import { KeyboardingCurriculumActivity } from 'types/schema-generated-types';

export const transformLessonPlan = (activity: KeyboardingCurriculumActivity) => ({
  ...activity,
  thumbnail: activity.activity.thumbnail?.src,
  asn: activity.sequenceNumber,
  week: activity.curriculumWeek.week,
  day: capitalize(activity?.dayOfWeek?.toLowerCase()),
  keys: activity.curriculumWeek.keys,
  name: activity.activity.activityTypeVariant.name,
  url: activity.activity.url,
  video: activity?.activity?.activityTypeVariant?.videos?.find(v => v?.device === 'DESKTOP')?.video
    .src,
  theme: {
    ...activity.curriculumWeek.curriculumTheme,
    icon: activity.curriculumWeek.curriculumTheme.thumbnail.src
  }
});
